<template>
  <v-card :loading="!users">
    <v-card-title>
      {{ $t("admin.users.approved") }}

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('admin.users.search')"
        single-line
        hide-details
        color="secondary"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      v-if="users"
      :headers="headers"
      :items="items"
      :search="search"
      :no-results-text="$t('admin.users.noResults')"
      dense
      multi-sort
    >
      <template #item.currentAuditPeriod="{ item }">
        <template v-if="item.currentAuditPeriod">
          {{ item.currentAuditPeriod.funds.length }}
        </template>
      </template>

      <template #item.actions="{ item }">
        <v-btn :to="{ name: 'adminUser', params: { id: item.id } }" color="secondary" icon small>
          <v-icon>mdi-eye </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { length, filter, includes, propSatisfies, __, curry, map } from "ramda";
import AdminUsersQuery from "@/gql/queries/AdminUsers.gql";

const countFunds = curry((prop, states, funds) => length(filter(propSatisfies(includes(__, states), prop), funds)));

export default {
  data() {
    return {
      search: "",
      users: null,
    };
  },

  apollo: {
    users: {
      query: AdminUsersQuery,
    },
  },

  computed: {
    approvedUsers() {
      return filter((user) => user.state === "APPROVED", this.users);
    },

    items() {
      return !this.approvedUsers
        ? null
        : map(
            (user) => ({
              ...user,
              name: user.firstname || user.lastname ? `${user.firstname} ${user.lastname}` : "",
              total: user.currentAuditPeriod ? user.currentAuditPeriod.funds.length : null,
              minimal: user.currentAuditPeriod ? countFunds("stepModel", [false], user.currentAuditPeriod.funds) : null,
              stepModel: user.currentAuditPeriod
                ? countFunds("stepModel", [true], user.currentAuditPeriod.funds)
                : null,
            }),
            this.approvedUsers
          );
    },

    headers() {
      return [
        {
          text: this.$t("admin.users.company"),
          value: "company.address.name",
          width: "50%",
        },
        {
          text: this.$t("admin.users.name"),
          value: "name",
          width: "50%",
        },
        {
          text: this.$t("admin.users.bookings"),
          value: "total",
        },
        {
          text: this.$t("admin.users.minimal"),
          value: "minimal",
        },
        {
          text: this.$t("admin.users.stepModel"),
          value: "stepModel",
        },
        {
          text: "",
          value: "actions",
          filterable: false,
          sortable: false,
          align: "right",
        },
      ];
    },
  },
};
</script>
